var link_viewer_default = {
  "fontElementMap": "SHwBD",
  "link": "_5v2xX",
  "linkInEditor": "xFAyd",
  "linkInViewer": "_7bWpT",
  "toolbarUrlContainer": "w1HeZ",
  "toolbarUrl": "K-Jv9",
  "toolbarUrlAnchor": "gXwK3"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
